/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import { tns } from '../../node_modules/tiny-slider/src/tiny-slider';
import { preventOverflow } from '@popperjs/core';


$(document).ready(() => {
  if ($('.slider-container').length > 0) {
    const slider = tns({
      container: '.testimonial-slider',
      loop: true,
      items: 1,
      nav: false,    
      autoplay: true,
      controls: false,
      speed: 200,
      autoplayButtonOutput: false,
      responsive: {
          640: {
              items: 1,
              gutter: 20,
          },
      }, 
    });
  }
});


$(document).ready(() => {
  $(".nav-dropdown").attr("data-toggle", "dropdown");
});

$(document).ready(() => {
  // console.log('Hello world');

  // Hamburger Menu
  $('.hamburger').click(function() {
    $(this).toggleClass('is-active');
  });


  //End of Script
});

$(window).scroll(function() {
  var height = $(window).scrollTop();
  if (height > 500) {
      $('#scrollup').fadeIn();
  } else {
      $('#scrollup').fadeOut();
  }
});

$('#scrollup-link').click(function() {
  $(window).scrollTop(0);
});


var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

$(document).ready(() => {
  if ($('.acf-form-submit').length > 0) {
    $('.acf-form-submit').before('<div id="catering-preview-wrap" class="row"><div id="catering-order-title"></div><div id="catering-order-preview" class="col-md-6"></div><div id="order-details-preview" class="col-md-6"></div></div>');
  }

});

function getCookie(c_name) {
  var c_value = " " + document.cookie;
  var c_start = c_value.indexOf(" " + c_name + "=");
  if (c_start == -1) {
      c_value = null;
  }
  else {
      c_start = c_value.indexOf("=", c_start) + 1;
      var c_end = c_value.indexOf(";", c_start);
      if (c_end == -1) {
          c_end = c_value.length;
      }
      c_value = unescape(c_value.substring(c_start,c_end));
  }
  return c_value;
}

$(document).ready(() => {

  var checkCookie = getCookie("express-shipping");

  if (checkCookie == null) {
    Cookies.set('express-shipping', 'false');
  }

});


$(document).ready(() => {
  $('.acf-field-group').find('.acf-field-range:first-of-type .acf-range-wrap input[type=number]').addClass("Half");
  $('.acf-field-group').find('.acf-field-range:last-of-type .acf-range-wrap input[type=number]').addClass("Full");
});


$("#catering-order").on("input textarea", function() {
  orderPreview();
});

$( ".acf-form-submit" ).hover(function() {
  orderPreview();
});

$('body').on('DOMSubtreeModified', '.select2-selection__rendered', function(){
  orderPreview();
});

  function orderPreview() {

  event.preventDefault();

  var orderPreview = "";
  var detailsPreview = "";
  var detailsEmail = "";
  var orderEmail = '<table style="margin-top:20px;" cellpadding="10px"><tr style="background-color:#3B1615;color:#FFFFFF;"><td>Item</td><td>Size</td><td>Quantity</td><td>Price</td><td>Tax</td><td>Ext. Cost</td></tr>';
  var price = "";
  var size = "";
  var qty = 0;
  var fieldDate = String($('.acf-date-picker').find('input[type=hidden]').val());
  var counter = 0;
  var lineItemCost = 0;
  var lineItemTax = 0;
  var totalCost = 0;
  var totalTax = 0;
  var rangeCounter = 0;
  var orderSize = "Half Order";
  const priceList = [];
  const qtyList = [];
  const sizeList = [];
  var percentage = 0;



  $( ".acf-field-group" ).each(function( index ) {

    rangeCounter = $(this).find('.acf-range-wrap input[type=number]').length;

    $(this).find('.acf-range-wrap input[type=number]').each(function( index ) {
      if($(this).val() > 0) {
        price = Number($(this).parent().find('.acf-prepend').html().replace(/[^0-9.-]+/g,""));
        qty = $(this).val();
        size = 
        priceList.push(price.toFixed(2));
        qtyList.push(qty);
        sizeList.push($(this).attr("class") + " Order");
      }
    });



    if (priceList !== undefined && priceList.length > 0) {

      if($(this).find('.acf-field-group').length === 0) {
        if($(this).find('input[type=radio]').length !== 0) {
          if($(this).find('label.selected input[value="yes"]').length !== 0) {
          orderPreview += '<div><h4>' + $(this).find('label').html() + ' (Dirt)</h4></div>';
          orderEmail += '<tr><td>' + $(this).find('label').html() + ' (Dirt)</td>';
          }
          else {
            orderPreview += '<div><h4>' + $(this).find('label').html() + ' (Regular)</h4></div>';
            orderEmail += '<tr><td>' + $(this).find('label').html() + ' (Regular)</td>';
          }
        }
        else {
          orderPreview += '<div><h4>' + $(this).find('label').html() + '</h4></div>';
          orderEmail += '<tr><td>' + $(this).find('label').html() + '</td>';
        }

        for (const val of priceList) {
          if (val > 1) {
            qty = qtyList[counter];
            orderSize = sizeList[counter];
            lineItemCost = (val*qty).toFixed(2);
            lineItemTax = (.0735 * lineItemCost).toFixed(2);
            totalCost += val*qty;
            totalTax += .0735 * lineItemCost;
 
            if (rangeCounter> 1) {
              orderPreview += '<div class="catering-order-line"><div>' + orderSize + ' $' + val + '</div><div>Quantity:' + qty + '</div><div>Cost = ' + '$' + (val*qty).toFixed(2) + '</div>';
              orderEmail += '<td>' + orderSize + '</td><td>' + qty + '</td><td>' + '$' + lineItemCost + '</td><td>$' + lineItemTax + '</td><td>$' + (+lineItemCost + +lineItemTax).toFixed(2) + '</td></tr>';
            }
            else {
              orderPreview += '<div class="catering-order-line"><div>' + ' $' + val + '</div><div>Quantity:' + qty + '</div><div>Cost = ' + '$' + (val*qty).toFixed(2) + '</div>';
              orderEmail += '<td></td><td>' + qty + '</td><td>' + '$' + lineItemCost + '</td><td>$' + lineItemTax + '</td><td>$' + (+lineItemCost + +lineItemTax).toFixed(2) + '</td></tr>';
            }
            counter++;
            orderPreview += "</div>";
          }
        }
        counter = 0;
      }
    else if($(this).find('.acf-field-group').length !== 0) {
      orderPreview += '<div><h3>' + $(this).find('label').html() + '</h3></div>';
    }
      priceList.length = 0;
      qtyList.length = 0;
      sizeList.length = 0;
    }

  });

  percentage = (totalTax).toFixed(2);

  orderPreview += '<h4 class="mt-3">Subtotal: $' + totalCost.toFixed(2) + '</h4><h4>Tax: $' + percentage + '</h4><h3>Total Cost: $' + (+totalCost + +percentage).toFixed(2) + '</h3>';

  detailsPreview = '<h3>Order Information</h3>';
  detailsEmail = '<table style="margin-top:20px;" cellpadding="10px">';

  $( ".af-field-user-information" ).each(function( index ) {
    $(this).find('.acf-field').each(function( index ) {
      if($(this).find('input').val()) {
        if($(this).hasClass('acf-field-date-picker')) {
          detailsPreview += '<div class="catering-order-line"><div>' + $(this).find('label').text().replace('*', '') + ':</div><div>' + fieldDate.slice(4,6) + "/" + fieldDate.slice(6,8) + "/" + fieldDate.slice(0, 4) + '</div></div>';
          detailsEmail += '<tr><td>' + $(this).find('label').text().replace('*', '') + ':</td><td>' + fieldDate.slice(4,6) + "/" + fieldDate.slice(6,8) + "/" + fieldDate.slice(0, 4) + '</td></tr>';
        }
        else {
        detailsPreview += '<div class="catering-order-line"><div>' + $(this).find('label').text().replace('*', '') + ':</div><div>' + $(this).find('input').val() + '</div></div>';
        detailsEmail += '<tr><td>' + $(this).find('label').text().replace('*', '') + ':</td><td>' + $(this).find('input').val() + '</td></tr>';
        }
      }

      if($(this).hasClass('acf-field-select')) {
        detailsPreview += '<div class="catering-order-line"><div>' + $(this).find('.acf-label label').text().replace('*', '') + ':</div><div>' + $(this).find('span.select2-selection__rendered').text() + '</div></div>';
        detailsEmail += '<tr><td>' + $(this).find('.acf-label label').text().replace('*', '') + ':</td><td>' + $(this).find('span.select2-selection__rendered').text() + '</td></tr>';
      }

      if($(this).find('textarea').val()) {
        detailsPreview += '<div class="catering-order-line"><div>' + $(this).find('label').text().replace('*', '') + ':</div><div>' + $(this).find('textarea').val() + '</div></div>';
        detailsEmail += '<tr><td>' + $(this).find('label').text().replace('*', '') + ':</td><td>' + $(this).find('textarea').val() + '</td></tr>';
        
      }
      
    });

        $(this).find('.acf-field-radio').each(function( index ) {
          detailsPreview += '<div class="catering-order-line"><div>' + $(this).find('.acf-label label').text() + ':</div><div>' + $(this).find('label.selected').text() + '</div></div>';
          detailsEmail += '<tr><td>' + $(this).find('.acf-label label').text() + ':</td><td>' + $(this).find('label.selected').text() + '</td></tr>';
    });



  });
  
  $('#catering-order-title').html('<h2>Order Preview</h2>');
  $('#catering-order-preview').html(orderPreview);
  $('#order-details-preview').html(detailsPreview);

  detailsEmail += '</table>';
  orderEmail += '</tr><tr style="background-color: #CCCCCC;font-weight: bold;"><td>Total</td><td colspan=2></td><td>$' + (totalCost).toFixed(2) + '</td><td>$' + (totalTax).toFixed(2) + '</td><td>$' + (+totalCost + +percentage).toFixed(2) + '</td></tr></table>';

  $('.af-field-email-subject').find('textarea').val(detailsEmail + orderEmail);

};


$(document).on('change', '#express-shipping', function() {

  if($(this).prop('checked')) {
    Cookies.set('express-shipping', 'true');
    location.reload();
  }
  else {
    Cookies.set('express-shipping', 'false');
    location.reload();
  }


});